<template>
  <div class="home">
    <a-row :gutter="16">
      <a-col :span="24">
        <a-card>
          <h2>Wykorzystane oprogramowanie</h2>
          <h3>Oprogramowanie i konfiguracja</h3>
          <ul>
            <li>
              <a href="#" target="_blank">Connect Ark by Togi Media Mateusz Pełka</a>
            </li>
            <li>
              <a href="#" target="_blank">Rajbot by Togi Media Mateusz Pełka</a>
            </li>
            <li>
              <a href="#" target="_blank">Moonshine System by Mateusz Karykowski System Solutions</a>
            </li>
          </ul>
          <h3>Ilustracje, grafiki i animacje</h3>
          <ul>
            <li>
              <a href="https://lottiefiles.com/79736-web-server" target="_blank">Animation (Web Server) by Mubshar Amin on
                LottieFiles</a>
            </li>

            <li>
              <a href="https://lottiefiles.com/68172-working-day" target="_blank">Animation (Working day) by Alexander
                Plaksin on LottieFiles</a>
            </li>

            <li>
              <a href="https://lottiefiles.com/70242-man-working" target="_blank">
                Man Working by Niveytha Waran on LottieFiles
              </a>
            </li>

            <li>
              <a href="https://lottiefiles.com/65094-computer-animation" target="_blank">Animation (computer animation) by
                Lorena Torres Espinosa on LottieFiles</a>
            </li>

            <li>
              <a href="https://lottiefiles.com/78298-loginv2" target="_blank">Animation (Loginv2) by Sadio
                Sangharé on LottieFiles</a>
            </li>

            <li>
              <a href="https://lottiefiles.com/95019-fishing-bye-bye" target="_blank">Animation (Fishing bye bye) by
                lah loe on LottieFiles</a>
            </li>
          </ul>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: "Credits",
  components: {},
  mounted() {
    this.$emit("loadedView");
  },
};
</script>
